<div *ngIf="!flagWorkSpace">
  <div class="container-workspace">
    <div class="row no-gutters">
      <div class="col-lg-12">
        <div class="d-flex align-items-center">
          <div class="w-100">
            <div class="row justify-content-center">
              <div>
                <div class="header text-center">
                  <div class="d-flex align-items-center justify-content-center">
                    <img
                      class="d-flex align-items-center"
                      src="assets/images/loa-bg.png"
                      width="40"
                      alt="logo"
                    />
                    <span class="display-7 text-white">Thanh toán</span>
                  </div>
                  <i class="fas fa-times font-size-22" (click)="onBack()"></i>
                </div>

                <div class="rounded px-4">
                  <div class="d-flex justify-content-between mt-3 mb-2">
                    <div class="mt-2">
                      <h4 class="list-shop-title">Danh sách cửa hàng</h4>
                    </div>
                    <div class="mb-2">
                      <button
                        class="btn-add-store btn-viettel"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#shopModal"
                      >
                        <div class="padding-plus">
                          <span class="plus-icon"> +</span>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div>
                    <div *ngFor="let index of listData;" class="custom-item">
                      <div class="d-flex align-items-center">
                        <span
                          class="material-symbols-outlined"
                          style="
                            padding: 6px;
                            margin-right: 8px;
                            border-radius: 50%;
                            background-color: #f5f7fe;
                            color: #141ed2;
                          "
                        >
                          storefront
                        </span>
                        <div class="p-2 w-100" (click)="showId(index)">
                          <div class="shop-name">
                            {{index.name}} - {{index.code}}
                          </div>
                          <div class="owner">{{index.leader}}</div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between my-1">
                        <hr class="m-0 mb-2" />
                        <button
                          class="button-custom"
                          (click)="toDevice(index)"
                          *ngIf="index?.is_direct === 1"
                        >
                          Liên kết loa
                        </button>
                        <button
                          class="button-custom"
                          (click)="toOrders(index)"
                          *ngIf="index?.is_shipper === 1"
                        >
                          Theo dõi đơn hàng
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="mt-4" />
              </div>
            </div>
            <!-- <div class="d-flex justify-content-center px-4 pb-5">
              <button class="btn-back" (click)="onBack()">
                Đóng ứng dụng
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    #shopModal
    class="modal fade bottom-modal"
    id="shopModal"
    tabindex="-1"
    aria-labelledby="shopModalLabel"
    aria-hidden="true"
    (hidden.bs.modal)="resetShop()"
  >
    <div class="modal-dialog modal-bottom">
      <div class="modal-content" style="border-radius: 1rem;">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold" id="shopModalLabel">
            Thêm cửa hàng
          </h5>
          <button
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body" style="overflow-y: auto; max-height: 70vh;">
          <div class="row m-0 p-0">
            <div class="form-group col-12">
              <label class="col-5 col-form-label required_label"
                >{{'Tên cửa hàng' | translate}}</label
              >
              <div class="col-12">
                <input type="text" class="form-control" [(ngModel)]="name" />
              </div>
            </div>
            <div class="form-group col-12">
              <label class="col-5 col-form-label required_label"
                >{{'Địa chỉ' | translate}}</label
              >
              <div class="col-12">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="terminalAddress"
                />
              </div>
            </div>
            <div class="form-group col-12">
              <label class="col-5 col-form-label required_label"
                >{{'Ngân hàng' | translate}}</label
              >
              <div class="col-12">
                <input
                  type="text"
                  class="form-control"
                  value="MB Bank"
                  readonly
                />
              </div>
            </div>
            <div class="form-group col-12">
              <label class="col-5 col-form-label required_label"
                >{{'Số tài khoản' | translate}}</label
              >
                <ng-select
                *ngIf="dataUser?.length > 0; else noData"
              [(ngModel)]="accountNumber"
              class="form-select"
              (change)="onInputBlur()"
              aria-label="Default select example"
              class="col-md-12"
            >
              <ng-option value="{{item.account_number}}" *ngFor="let item of dataUser"
                >{{item.account_number}}</ng-option
              >
            </ng-select>
              <ng-template #noData>
                <div class="col-12">
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="accountNumber"
                    (blur)="onInputBlur()"
                  />
                </div>
              </ng-template>
              
             
            </div>
            <span
              class="text-danger font-italic font-size-12"
              *ngIf="!searching"
              >Cần nhập tài khoản ngân hàng để thêm cửa hàng</span
            >

            <div class="form-group col-12" >
              <label class="col-5 col-form-label required_label"
                >{{'Chủ tài khoản' | translate}}</label
              >
              <div class="col-12">
                <input
                  type="text"
                  [(ngModel)]="bank_accountName"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="modal-footer d-flex justify-content-end col-12 px-4 mb-2"
        >
          <button type="button" class="btn" data-bs-dismiss="modal">
            Đóng
          </button>
          <button type="button" class="btn-viettel" [disabled]="!bank_accountName || !name || !terminalAddress" (click)="saveData()">
            Thêm cửa hàng
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
